import { Observer, Subject } from 'rxjs';

export type EventName =
  | 'SIGN_IN'
  | 'SIGNED_IN'
  | 'SIGNED_OUT'
  | 'TRIGGER_LANGUAGE_CHANGE'
  | 'UNSTABLE_NETWORK';

type EventEmitterProps<T = {}> = {
  event: EventName;
  data?: T;
};

class MyEvent {
  private eventEmitter: Subject<EventEmitterProps<any>>;

  constructor() {
    this.eventEmitter = new Subject<EventEmitterProps<any>>();
  }

  emit<T = {}>(props: EventEmitterProps<T>) {
    this.eventEmitter.next(props);
  }

  subscribe<T = {}>(props: Partial<Observer<EventEmitterProps<T>>>) {
    this.eventEmitter.subscribe(props);
  }
}

export const myEvent = new MyEvent();
